"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngageAppMessage = exports.EngageMessageType = void 0;
var EngageMessageType;
(function (EngageMessageType) {
    //Client to server
    EngageMessageType["Initiate"] = "initiate";
    EngageMessageType["CreateLobby"] = "create-lobby";
    EngageMessageType["KillLobby"] = "kill-lobby";
    EngageMessageType["GetHostCode"] = "get-host-code";
    EngageMessageType["CheckLobby"] = "check-lobby";
    EngageMessageType["JoinLobby"] = "join-lobby";
    EngageMessageType["UpdateUser"] = "update-user";
    EngageMessageType["GetLobbyInfo"] = "get-lobby-info";
    EngageMessageType["GetDownloadState"] = "get-download-state";
    EngageMessageType["SetState"] = "set-state";
    EngageMessageType["TimeSync"] = "timesync";
    //Server to Client
    EngageMessageType["LobbyJoined"] = "lobby-joined";
    EngageMessageType["LobbyUpdated"] = "lobby-updated";
    EngageMessageType["LobbyValid"] = "lobby-valid";
    EngageMessageType["LobbyError"] = "lobby-error";
    EngageMessageType["LobbyKilled"] = "lobby-killed";
    EngageMessageType["UserUpdated"] = "user-updated";
    EngageMessageType["AppStateUpdated"] = "app-state-updated";
    EngageMessageType["UserStateUpdated"] = "user-state-updated";
    EngageMessageType["StateBroadcast"] = "state-broadcast";
    EngageMessageType["HostLobbyUpdated"] = "host-lobby-updated";
})(EngageMessageType = exports.EngageMessageType || (exports.EngageMessageType = {}));
//Don't include this in the enum above as we use membership in that enum
// to determine if it's a platform or app message.
// See context.tsx -> sendMessage function.
exports.EngageAppMessage = "app-message";
//# sourceMappingURL=messages.js.map